module.exports = __webpack_public_path__ + "img/iconDown.37db7948.svg";